import { Vertrag, VertragTarif } from '@/domain/vertraege/shared/types/vertrag';
import { ProgressCircle } from './ProgressCircle';
import { t } from 'i18next';

export function Abrechnungsart({ vertrag }: { vertrag: Vertrag }) {
  return (
    <div className="w-full flex flex-col gap-2">
      <div>
        {vertrag.vertragTarif === VertragTarif.MITARBEITER
          ? t('domain.vertraege.slide.employeePartTitle')
          : t('domain.vertraege.slide.locationPartTitle')}
      </div>
      <div className="flex gap-3 items-center">
        <ProgressCircle
          vertrag={vertrag}
          percentage={Math.round(
            (vertrag.aktiveAnzahl / vertrag.vereinbarteAnzahl) * 100,
          )}
        />
        <div className="w-2/3">
          <div className="w-full font-medium">
            <span className="text-neutrals-800 dark:text-white text-xl">
              {vertrag.aktiveAnzahl}
            </span>
            <span className="text-neutrals-700 dark:text-white"> / </span>
            <span className="text-neutrals-700 text-xs">
              {vertrag.vereinbarteAnzahl}
            </span>
          </div>
          <div className="text-xs">
            {vertrag.vertragTarif === VertragTarif.MITARBEITER
              ? t('domain.vertraege.slide.employeeTitle')
              : t('domain.vertraege.slide.locationTitle')}
          </div>
        </div>
      </div>
    </div>
  );
}
